(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('TypeAvoirDeleteController',TypeAvoirDeleteController);

    TypeAvoirDeleteController.$inject = ['$uibModalInstance', 'entity', 'TypeAvoir'];

    function TypeAvoirDeleteController($uibModalInstance, entity, TypeAvoir) {
        var vm = this;
        vm.typeAvoir = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TypeAvoir.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
